var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var _require = require('../primitives'),
    STRING = _require.STRING;

var _require2 = require('../../util'),
    isString = _require2.isString;

var email = _objectSpread({}, STRING, {
  type: function type(val) {
    return isString(val) && /\S+@\S+\.\S+/.test(val);
  },
  user: function user(val, f) {
    return f(val.match(/(\S+)@\S+\.\S+/)[1]);
  },
  domain: function domain(val, f) {
    return f(val.match(/\S+@(\S+)\.\S+/)[1]);
  }
});

module.exports = email;